import { installLegacyWebViewGlobals } from './bootstrap/legacyWebView';
import { renderStartupFailure } from './bootstrap/startupRecovery';

// Android 7 can still expose a Chrome 69 WebView, which predates globalThis.
// Install this before lazily loading the application and its dependencies.
installLegacyWebViewGlobals(window);

void import('./main.jsx').catch(() => {
  // Error objects can contain the OAuth callback URL; log only a safe code.
  console.error('[bootstrap] APP_STARTUP_FAILED');
  renderStartupFailure();
});
